import { TherapistAction } from 'src/redux/actions/constant';

const intialState: object = {
  response: null,
  data: [],
  loading: false,
  isTimeEdited: false,
};

export const setCommonDurationReducer = (state = intialState, action: any) => {
  switch (action.type) {
    case TherapistAction.SET_COMMON_DURATION_FOR_GC_SUCCESS: {
      return {
        ...state,
        response: action.payload,
        data: action.payload.data,
        loading: false,
        isTimeEdited: true,
        isAssigned: action?.isAssigned,
      };
    }
    case TherapistAction.SET_COMMON_DURATION_FOR_GC_FAILURE: {
      return {
        ...state,
        response: action.payload,
        loading: false,
        isTimeEdited: false,
      };
    }
    case TherapistAction.SET_COMMON_DURATION_FOR_GC_REQUEST:
      return {
        ...state,
        loading: true,
        isTimeEdited: false,
      };

    case TherapistAction.SET_COMMON_DURATION_FOR_GC_RESET:
      return {
        ...state,
        response: null,
        loading: false,
        isTimeEdited: false,
      };

    default:
      return state;
  }
};
